import request from '../utils/request';

// 查询热门标讯列表
export function getBxList() {
  return request({
    url: '/getBiaoxun?apipost_id=5e44e2f9b01f',
    method: 'get',
  });
}
